import React from "react";
import { ReactComponent as BrandLogo } from "../assets/svg/logo_nameplate.svg";
import styles from "./Footer.module.css";

const columns = [
    {
        heading: "ROBOTICS",
        links: [
            { label: "Overview", href: "/robotics" },
            { label: "Mobile Robots", href: "/robotics/mobile" },
            { label: "Perception SDK", href: "/robotics/perception" },
        ],
    },
    {
        heading: "FINANCE",
        links: [
            { label: "Overview", href: "/finance" },
            { label: "Company Overview", href: "/finance/overview/AAPL" },
            { label: "S&P 500", href: "/finance/sp500" },
            { label: "S&P 500 Performance", href: "/finance/sp500/performance" },
            { label: "Equity Search", href: "/finance/markets" },
        ],
    },
    {
        heading: "COMPANY",
        links: [
            { label: "About Us", href: "/about" },
            { label: "Documentation", href: "/docs" },
            { label: "Posts", href: "/" },
            { label: "Publications", href: "/" },

        ],
    },
    /* Block out for now
    {
        heading: "LEGAL",
        links: [
            { label: "Security", href: "/security" },
            { label: "Privacy", href: "/privacy" },
            { label: "Terms", href: "/terms" },
        ],
    },
    */
];

export default function Footer() {
    return (
        <footer className={styles.footer} role="contentinfo">
            <div className={styles.container}>
                {/* Brand + Mission + CTAs (left) */}
                <div className={styles.brand}>
                    <a className={styles.brandRow} href="/">
                        <BrandLogo className={styles.brandLogo} />
                    </a>

                    <p className={styles.mission}>
                        Our mission is to empower builders and investors with intelligent
                        systems. Helping our customers Move Faster, Solve Smarter, and Stay Ahead.
                    </p>

                    <div className={styles.ctas}>
                        <a className={styles.cta} href="mailto:info@pulserobotics.com">
                            CONTACT&nbsp;US
                        </a>
                        <a className={styles.cta} href="/careers">
                            JOIN OUR TEAM
                        </a>
                    </div>

                    <p className={styles.copySmall}>
                        © {new Date().getFullYear()} Pulse Robotics. All rights reserved.
                    </p>
                </div>

                {/* Link Columns (right) */}
                <nav className={styles.columns} aria-label="Footer">
                    {columns.map((col) => (
                        <div key={col.heading} className={styles.col}>
                            <h4 className={styles.colHeading}>{col.heading}</h4>
                            <ul className={styles.linkList}>
                                {col.links.map((l) => (
                                    <li key={l.label}>
                                        <a href={l.href} className={styles.linkItem}>
                                            {l.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </nav>
            </div>
        </footer>
    );
}
